import { Clock } from 'lucide-react';

/** 時間・複雑度に見合わないタブの「準備中」プレースホルダー (v0.2.5 S-11、CLAUDE.md §6d /
 *  docs/design/v025-sprint-plan.md §6 リスクレジスタの方針に基づき地域/通貨・AI設定タブを対象に使用)。 */
export function PlaceholderSettingsPage({ title, description }: { title: string; description: string }) {
  return (
    <div className="space-y-4 max-w-xl">
      <h2 className="text-h2">{title}</h2>
      <div className="border border-neutral-line rounded-lg bg-white p-8 text-center text-neutral-sub">
        <Clock size={28} className="mx-auto mb-3 text-neutral-sub" />
        <p className="font-medium">準備中です</p>
        <p className="text-sm mt-1">{description}</p>
      </div>
    </div>
  );
}
